<script setup>
import { useCasinoGamesStore } from "~/stores/casino-games";
import { useRoute } from "vue-router";
import { computed } from "vue";

const casinoGamesStore = useCasinoGamesStore();
const route = useRoute();

watch(route, () => {
  casinoGamesStore.state.categoryName = null;
}, { deep: true, immediate: false });

const title = computed(() => {
  if (casinoGamesStore.state.searchByProvider.length > 2) {
    return (
      casinoGamesStore.state.providersSelected.slice(0, 2).join(", ") +
      " e outros " +
      (casinoGamesStore.state.providersSelected.length - 2) +
      "."
    );
  }
  if (casinoGamesStore.state.searchByProvider.length > 0) {
    return casinoGamesStore.state.providersSelected.length > 0
      ? "da " + casinoGamesStore.state.providersSelected.join(", ")
      : "";
  }
  return "";
});

const searchName = computed(() => {
  return casinoGamesStore.state.searchString !== ""
    ? `com a palavra '${casinoGamesStore.state.searchString}'`
    : null;
});

const headerTitle = computed(() => {
  if (casinoGamesStore.state.categoryName) {
    return `Os populares de: ${casinoGamesStore.state.categoryName}`;
  }
  return '';
}
);

</script>

<template>
  <div>
    <div class="flex justify-between gap-2 min-h-[18px]">
      <h3 class="w-[80%] select-none text-ellipsis text-sm font-semibold text-white lg:text-base">
        {{ headerTitle }}
        {{ title }}
        {{ searchName }}
      </h3>
      <button v-if="
        casinoGamesStore.state.searchString ||
        casinoGamesStore.state.providersSelected.length > 0
      " @click="
        casinoGamesStore.resetFilters();
      casinoGamesStore.get();
      " class="h-max rounded bg-gray-600 p-1 text-xs">
        Limpar filtros
      </button>
    </div>
  </div>
</template>
